export default function NumberCell(props: any) {
    return (
        <div className="text-center mx-2">
            {String(props.cell.value)}
        </div>
    )
}
